<template>
  <a
    :href="to"
    class="greenButtonLink"
    :class="{ autoWidth, black }"
    v-if="isNotRouterLink"
  >
    <slot></slot>
  </a>
  <router-link :to="to" v-else class="greenButtonLink">
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  mounted() {},
  props: {
    to: { type: [Object, String] },
    autoWidth: { type: Boolean, default: false },
    black: { type: Boolean, default: false }
  },
  computed: {
    isNotRouterLink() {
      if (typeof this.to == 'string') {
        if (this.to.charAt(0) == '/') {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss">
.greenButtonLink {
  background-color: $volt;
  border-radius: 3px;
  height: 33px;
  width: 210px;
  min-width: max-content;
  display: inline-block;
  line-height: 33px;
  font-weight: 500;
  text-align: center;
  display: block;
  margin: 0px auto;
  padding: 0px 10px;
  box-sizing: border-box;

  &.black {
    background-color: black;
    color: white;
  }

  &.autoWidth {
    width: max-content;
    padding: 0px 20px;
  }
  @media screen and (hover: hover) {
    &:hover {
      background-color: $voltHover;
    }
    &.black:hover {
      background-color: $darkGrey;
    }
  }
}
</style>
